import React, { useState } from 'react'
import {
  FormDashboardTextarea,
  PopupBasic,
  SaveButton
} from '../../../components'
import { activityStatus } from '../../../constants'
import { useInternationalization } from '../../../features/i18n'

const labelTitle = {
  en: 'Event Cancellation',
  id: "Pembatalan Event"
}

const labelPlaceholder = {
  en: 'Write message',
  id: "Tulis pesan"
}

const SidebarCancel = ({handleSubmit}) => {
  const [cancelReason, setCancelReason] = useState('')
  const [showCancelPopup, setShowCancelPopup] = useState(false)
  const { translate, language } = useInternationalization()

  const handleCancel = (e) => {
    console.log('save as cancelled')
    e.preventDefault()
    e.stopPropagation()

    handleSubmit({
      statusActivity: activityStatus.cancelled,
      cancelReason
    })
  }

  return <>
    <div
      className="mt-5 text-center text-xs text-gray-500 underline cursor-pointer"
      onClick={() => setShowCancelPopup(true)}
    >
      {translate('EVENT', 'cancel')}
    </div>

    {
      showCancelPopup &&
      <PopupBasic title={labelTitle[language.name]} onClose={() => setShowCancelPopup(false)}>
        <p className="text-sm mb-6 text-gray-444">
          {translate('EVENT', 'cancel_message')}
        </p>
        <FormDashboardTextarea
          className="w-full mb-8"
          placeholder={labelPlaceholder[language.name]}
          onChange={e => setCancelReason(e.target.value)}
        />
        <div className="flex flex-wrap items-center">
          <div className="w-full md:w-auto lg:w-auto">
            <SaveButton mobileClassname="mb-5" onClick={handleCancel}/>
          </div>
          <div className="w-full md:w-auto lg:w-auto text-center lg:text-left">
            <p className="cursor-pointer px-8 text-gray-444 underline text-xs lg:text-sm" onClick={() => setShowCancelPopup(false)}>
              {translate('GENERAL', 'cancel')}
            </p>
          </div>
        </div>

      </PopupBasic>
    }
  </>
}

export default SidebarCancel
